var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "left-user" }, [
    _c(
      "div",
      { staticClass: "left-top-search" },
      [
        _c("el-input", {
          staticClass: "inline-block",
          attrs: {
            "prefix-icon": "el-icon-search",
            size: "mini",
            id: "filter-users",
            placeholder: "搜索"
          },
          on: { input: _vm.filterUserChange },
          model: {
            value: _vm.filterText,
            callback: function($$v) {
              _vm.filterText = $$v
            },
            expression: "filterText"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.pageType === "1"
      ? _c("div", { staticClass: "user-list" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "padding-0 mg-0 border-bottom",
              attrs: { id: "allUserList" }
            },
            _vm._l(_vm.allUsersShowData, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: [
                    "border-bottom",
                    "name-li",
                    item.isOnline ? "" : "unlive",
                    item.isClick ? "active" : ""
                  ],
                  on: {
                    click: function($event) {
                      return _vm.getChart(0, item)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: item.user.avatarImageUrl
                        ? item.user.avatarImageUrl
                        : require("../../../static/avatar.jpg")
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    class: item.hasUnReadLog ? "message-circle" : ""
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "name-content" }, [
                    _c("div", [
                      _c("span", { staticClass: "name ellipse inline-block" }, [
                        _vm._v(_vm._s(item.user.userName))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "time" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getChatTimeAndContent(item.lastChat, false)
                              .createdTime
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "content ellipse",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.getChatTimeAndContent(item.lastChat, false)
                            .content
                        )
                      }
                    })
                  ])
                ]
              )
            }),
            0
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "group-list" }, [
      _c(
        "div",
        { staticClass: "user-list-title bd-top" },
        [
          _c("span", [_vm._v("群组列表")]),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: "dropdown add-icon pull-right",
              on: { command: _vm.command }
            },
            [
              _c("span", [
                _c("div", {
                  staticClass: "iconfont icon-xinzeng cursor",
                  attrs: {
                    id: "dLabel",
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", { attrs: { command: "addGroup" } }, [
                    _vm._v("加入群")
                  ]),
                  _vm._v(" "),
                  _vm.pageType === "1"
                    ? _c(
                        "el-dropdown-item",
                        { attrs: { command: "createGroup" } },
                        [_vm._v("创建群")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "padding-0 mg-0", attrs: { id: "allChatGroupList" } },
        _vm._l(_vm.allGroupsShowData, function(item, index) {
          return _c(
            "li",
            {
              key: index,
              class: ["border-bottom", item.isClick ? "active" : "", "name-li"],
              on: {
                click: function($event) {
                  return _vm.getChart(1, item)
                }
              }
            },
            [
              _c("div", [
                _c("div", { staticClass: "group-img" }, [
                  _vm._v(_vm._s(item.groupName.substring(0, 1)))
                ]),
                _vm._v(" "),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.hasUnReadLog,
                      expression: "item.hasUnReadLog"
                    }
                  ],
                  staticClass: "message-circle"
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "name-content" }, [
                _c("div", [
                  _c(
                    "span",
                    { staticClass: "title-name name ellipse inline-block" },
                    [_vm._v(_vm._s(item.groupName))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "time" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getChatTimeAndContent(item.lastChat, true)
                          .createdTime
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "content ellipse",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.getChatTimeAndContent(item.lastChat, true).content
                    )
                  }
                })
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "user-list-title" }, [
      _c("span", [_vm._v("好友列表")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bba9856", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bba9856","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/chat/src/chat-list.vue
// module id = null
// module chunks = 